import React, { useEffect, useState, useMemo } from 'react';
import { 
  ArrowRight, PlusCircle, MinusCircle, Download, Landmark, Wallet, Percent, FileText, ChevronRight,
  PiggyBank,
  BriefcaseBusiness,
  BadgeDollarSign,
  Upload,
  DownloadCloud,
  HandCoins,
  X,
  Info,
  Check,
  ScanEye
} from 'lucide-react';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import CurrencyInput from "react-currency-input-field";
import styles from './LoanApplication.module.css';
import Sidebar2 from '../../Components/SideBar2/SideBar2';
import Header2 from '../../Components/Header2/Header2';
import Swal from "sweetalert2";
import { BASE_URL } from '../../Components/Api/Api';
import axios from 'axios';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { FaFileImage, FaFilePdf } from 'react-icons/fa';




export default function LoanApplication() {
  const navigate = useNavigate();
  const [tenureError, setTenureError] = useState('');
  const [guarantorError, setGuarantorError] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [isEligible, setIsEligible] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [loanAmount, setLoanAmount] = useState('');
  const [calcSelectedOption, setCalcSelectedOption] = useState(null);
  const interestRate = calcSelectedOption?.rawProduct?.interest_rate || 0;
  const [tenure, setTenure] = useState('');
  const [guarantors, setGuarantors] = useState([]);
   const [amount, setAmount] = useState("");
  const [selectedPreviewImage, setSelectedPreviewImage] = useState(null);
   // Step 1 Form Data
    //  const [loanType, setLoanType] = useState('');
    //  const [loanPurpose, setLoanPurpose] = useState('');
    //  const [repaymentMethod, setRepaymentMethod] = useState('');
    //  const [account, setAccount] = useState('');
     
     // Step 3 Documents
     const [documentName, setDocumentName] = useState('');
     const [uploadedDocuments, setUploadedDocuments] = useState([]);

  const [loanProducts, setLoanProducts] = useState([]);
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);
  const steps = [
    { number: 1, title: 'Loan Details', description: 'Provide loan information' },
    { number: 2, title: 'Guarantors', description: 'Add your guarantors' },
    { number: 3, title: 'Documents', description: 'Upload required documents' },
    { number: 4, title: 'Review & Submit', description: 'Review and submit' }
  ];

  const [loanData, setLoanData] = useState({
      // Step 1
    loanType: "",
    loanPurpose: "",
    amount: "",
    repaymentTenure: "",
    disbursementAccount: "",
    // Step 2
    guarantors: [],
    // Step 3
    documents: null,
    // Step 4
    // review: false,
  });

useEffect(() => {
  const fetchLoanProducts = async () => {
    // 1. Pull required identifiers from localStorage
    const token = localStorage.getItem("token");
    const companyId = localStorage.getItem("companyId");
        // const compid = localStorage.getItem("companyId");
    const memberid = localStorage.getItem("memberId");

    // if (!companyId) {
    //   console.warn("company_id is missing from localStorage.");
    //   setLoanProducts([]);
    //   return;
    // }

    setIsLoadingProducts(true);
    try {
      // 2. Pass company_id as a query parameter & attach your Bearer token if required
      const res = await axios.get(`${BASE_URL}/company_loan_products`, {
        params: { 
          company_id: companyId, 
          member_id: memberid,
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      // 3. Drill down into your exact response schema: res.data.data
      if (res.data && Array.isArray(res.data.data)) {
        
        // 4. Format directly for react-select options configuration structure
        const formattedProducts = res.data.data.map((product) => ({
          value: product.id,        // unique identifier for the tracking value
          label: product.loan_name,      // string displayed in the searchable dropdown text
          rawProduct: product       // nesting the complete object here so you can access it later
        }));

        setLoanProducts(formattedProducts);
      } else {
        setLoanProducts([]);
      }
    } catch (err) {
      console.error("Failed fetching products:", err);
      setLoanProducts([]);
    } finally {
      setIsLoadingProducts(false);
    }
  };

  fetchLoanProducts();
}, []);

const handleSelectProductChange = (selectedOption) => {
  setLoanData(prev => ({
    ...prev,
    loanType: selectedOption ? selectedOption.value : "",
    selectedProductDetails: selectedOption ? selectedOption.rawProduct : null,

    // Clear dependent fields
    repaymentTenure: "",
    amount: "",
  }));

  // Clear validation errors
  setTenureError("");
  setAmountError("");
  setEligibilityError("");

  if (selectedOption?.rawProduct) {
    console.log("Full selected product data layout:", selectedOption.rawProduct);
  }

  if (selectedOption) {
    handleEligibility(selectedOption.value);
  } else {
    setIsEligible(false);
  }
};

  const { estimatedInterest, totalRepayment, monthlyRepayment } = useMemo(() => {
  const amount = Number(loanAmount) || 0;
  const months = Number(tenure) || 0; // Use 0 fallback to prevent early calculations if empty

  // Simple interest calculations
  const totalInterest = amount * (interestRate / 100) * (months / 12);
  const total = amount + totalInterest;
  const monthly = months > 0 ? total / months : 0;

  return {
    estimatedInterest: totalInterest,
    totalRepayment: total,
    monthlyRepayment: monthly,
  };
}, [loanAmount, tenure, interestRate]);

const handleCalcProductChange = (selectedOption) => {
  setCalcSelectedOption(selectedOption);
};

// 5. This handles the formal synchronization with your multi-step "loanData"
const syncCalculatorToForm = (e) => {
  e.preventDefault(); // Stop form submission behavior if wrapped inside tags
  
  setLoanData(prev => ({
    ...prev,
    loanType: calcSelectedOption ? calcSelectedOption.value : "",
    amount: loanAmount.toString(),
    repaymentTenure: tenure.toString(),
    // Keep this isolated reference object inside loanData only if required by later steps
    selectedProductDetails: calcSelectedOption ? calcSelectedOption.rawProduct : null
  }));
  
  console.log("Calculator data synchronized to Form Step 1 successfully!");
};

  // console.log(loanData?.selectedProductDetails)
  
const guarantorsRequired = Number(
  loanData?.selectedProductDetails?.required_guarantor_no
);
console.log(guarantorsRequired);

useEffect(() => {
    const total =
        Number(loanData?.selectedProductDetails?.required_guarantor_no) || 1;

    const data = Array.from({ length: total }, (_, index) => ({
        id: index + 1,
        memberNumber: "",
        fullName: "",
        email: "",
        phone: "",
        address: "",
        relationship: "",
        loading: false,
        fetched: false
    }));

    setGuarantors(data);
}, [loanData?.selectedProductDetails]);


  const handleChange = (e) => {
  const { name, value } = e.target;

  setLoanData(prev => ({
    ...prev,
    [name]: value
  }));
};
const handleCurrencyChange = (name, value) => {
  setLoanData(prev => ({
    ...prev,
    [name]: value || "",
  }));
};

const requiredFields = {
  1: [
    "loanType",
    "loanPurpose",
    "amount",
    "repaymentTenure"
  ],

  2: [
    "fullName",
    "email",
    "phone",
    "relationship",
    "address"
  ],

  3: [
    "documents"
  ]
};
const isCurrentStepValid = () => {
  // --- Step 1 Validation ---
  if (currentStep === 1) {
    // 1. Check if all required fields are filled and not empty/default
    const fields = requiredFields[1];
    const allFieldsFilled = fields.every(field => {
      const value = loanData[field];
      if (!value || value.toString().trim() === "") return false;
      if (value === "Select Purpose") return false;
      return true;
    });

    if (!allFieldsFilled) return false;

    // 2. Check if the user is eligible (must be true, no errors, not loading)
    const isEligibilityValid = isEligible && !eligibilityError && !eligibilityLoading;
    if (!isEligibilityValid) return false;

    // 3. Validate repayment tenure limits
    const enteredTenure = parseInt(loanData.repaymentTenure, 10);
    const maxTenure = parseInt(loanData?.selectedProductDetails?.max_tenure || 0, 10);
    // Defaults to 1 if min_tenure is not explicitly provided
    const minTenure = parseInt(loanData?.selectedProductDetails?.min_tenure || 1, 10); 

    const isTenureWithinBounds = 
      !isNaN(enteredTenure) && 
      enteredTenure >= minTenure && 
      enteredTenure <= maxTenure &&
      !tenureError; // Also ensures there is no active UI validation error string

    return isTenureWithinBounds;
  }

  // --- Step 2 Validation ---
  if (currentStep === 2) {
    // If the loan product doesn't require any guarantors, step 2 is automatically valid!
    if (guarantorsRequired === 0) return true;

    if (guarantors.length < guarantorsRequired) return false;
    
    // Checks if every required guarantor entry has been successfully fetched via the API
    return guarantors.every(g => g.fetched && g.fullName && g.email && g.phone);
  }

  // --- Step 3 Validation ---
  if (currentStep === 3) {
    return true; // Next button remains enabled regardless of uploads
  }

  return true;
};

const isGuarantorsValid = () => {

    if (guarantors.length === 0) return true;

    return guarantors.every(g =>

        g.fullName?.trim() &&
        g.email?.trim() &&
        g.phone?.trim() &&
        g.address?.trim()

    );

};


  // const interestRate = 0.02; // 2%
  // const estimatedInterest = loanAmount * interestRate;
  // const totalRepayment = loanAmount + estimatedInterest;
  // const monthlyRepayment = totalRepayment / tenure;

  const goToStep = (step) => {

    // Going backward is always allowed
    if (step < currentStep) {
        setCurrentStep(step);
        return;
    }

    // Prevent skipping multiple steps
    if (step > currentStep + 1) {
        // Swal.fire({
        //     icon: "info",
        //     title: "Complete Previous Steps",
        //     text: "Please complete the previous steps first."
        // });
        return;
    }

    // Validate current step
    if (!isCurrentStepValid()) {
        // Swal.fire({
        //     icon: "warning",
        //     title: "Incomplete Form",
        //     text: "Please complete all required fields."
        // });
        return;
    }

    setCurrentStep(step);
};

const handleTenureBlur = (e) => {
  const enteredValue = parseInt(e.target.value, 10);
  
  // Safeguard values from your selected product details
  const minTenure = parseInt(loanData?.selectedProductDetails?.min_tenure || 1, 10);
  const maxTenure = parseInt(loanData?.selectedProductDetails?.max_tenure || 12, 10);

  if (!isNaN(enteredValue)) {
    if (enteredValue < minTenure || enteredValue > maxTenure) {
      // Clear the value in your loanData state
      setLoanData(prev => ({
        ...prev,
        repaymentTenure: ''
      }));
      // Set the validation error message
      setTenureError(`You can only apply within ${minTenure} to ${maxTenure} months.`);
    } else {
      // Clear the error if the value is within limits
      setTenureError('');
    }
  }
};

// 1. Declare the amount error state alongside your tenure error state
const [amountError, setAmountError] = useState('');

// Assumed dynamic limits fetched from your cooperative's settings API
// (Replace these fallbacks with your actual state variables holding the config limits)
const minAllowedAmount = loanData?.selectedProductDetails?.minimum_amount || 10000; 
const maxAllowedAmount = loanData?.selectedProductDetails?.max_amount || 1000000;

// 2. Add the Amount Blur Validation Handler
const handleAmountBlur = () => {
  const numericAmount = parseFloat(loanData.amount);

  // If empty, don't throw an limit validation error yet (handled by overall form submission)
  if (!loanData.amount || isNaN(numericAmount)) {
    return;
  }

  if (numericAmount < minAllowedAmount) {
    setAmountError(`Minimum loan amount allowed is ₦${minAllowedAmount.toLocaleString()}`);
    // Clear the invalid loan amount value from state
    setLoanData(prev => ({ ...prev, amount: '' }));
  } else if (numericAmount > maxAllowedAmount) {
    setAmountError(`Maximum loan amount allowed is ₦${maxAllowedAmount.toLocaleString()}`);
    // Clear the invalid loan amount value from state
    setLoanData(prev => ({ ...prev, amount: '' }));
  } else {
    setAmountError('');
  }
};

const [memberLoading, setMemberLoading] = useState(false);
const [eligibilityLoading, setEligibilityLoading] = useState(false);
const [memberNumber, setMemberNumber] = useState(false);
const [eligibilityError, setEligibilityError] = useState('');

const handleFetchMember = async (id, memberNumber) => {
  const token = localStorage.getItem("token");

  if (!memberNumber) {
    Swal.fire({
      icon: "warning",
      title: "Member Number Required",
      text: "Please enter a member number."
    });
    return;
  }

  setMemberLoading(true);
  setGuarantorError('');

  try {
        const compid = localStorage.getItem("companyId");
    const memberid = localStorage.getItem("memberId");
    const res = await axios.get(
      `${BASE_URL}/member-auth/fetch_member_details`,
      {
        params: {
          member_number: memberNumber,
          company_id: compid,
          member_id: memberid,
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    // if (res.data?.status === "success") {
      const member = res.data.data;

      setGuarantors(prev =>
        prev.map(g =>
          g.id === id
            ? {
                ...g,
                memberNumber,
                fullName: member.name,
                email: member.email,
                phone: member.phone_number,
                address: member.address,
                fetched: true
              }
            : g
        )
      );
  } catch (err) {
    console.error(err);
    setGuarantorError( err.response?.data?.message);
setMemberNumber(false);
    // Swal.fire({
    //   icon: "error",
    //   title: "Request Failed",
    //   text:
    //     err.response?.data?.message ||
    //     "Unable to fetch member details. Please try again."
    // });
  } finally {
    setMemberLoading(false);
  }
};

const handleEligibility = async (loanProductId) => {
  const token = localStorage.getItem("token");

  setEligibilityLoading(true);
  setEligibilityError('');
  setIsEligible(false);

  try {
        const compid = localStorage.getItem("companyId");
    const memberid = localStorage.getItem("memberId");
    const res = await axios.get(
      `${BASE_URL}/member-auth/check_loan_eligibility`,
      {
        params: {
          loan_name: loanProductId,
          member_id: memberid,
          company_id: compid,
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (res.data?.status === "success" || res.status === 200) {
      setIsEligible(true);
      const member = res.data.data;
    }

    
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        const { message } = error.response.data;
        if (typeof message === 'string') errorMessage = message;
        else if (Array.isArray(message)) errorMessage = message.join('; ');
        else if (typeof message === 'object') {
          const firstKey = Object.keys(message)[0];
          const messages = message[firstKey];
          errorMessage = Array.isArray(messages) ? messages.join('; ') : messages;
        }
      }
    setEligibilityError(errorMessage);

    // Swal.fire({
    //   icon: "error",
    //   title: "Request Failed",
    //   text:
    //     err.response?.data?.message ||
    //     "Unable to fetch member details. Please try again."
    // });
  } finally {
    setEligibilityLoading(false);
  }
};



const handleNext = () => {
  goToStep(currentStep + 1);

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const handleBack = () => {
  if (currentStep > 1) {
    setCurrentStep(currentStep - 1);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
};

  const addGuarantor = () => {
    const newId = Math.max(...guarantors.map(g => g.id), 0) + 1;
    setGuarantors([...guarantors, { id: newId, fullName: '', email: '', phone: ''}]);
  };

  const removeGuarantor = (id) => {
    setGuarantors(guarantors.filter(g => g.id !== id));
  };

const handleGuarantorChange = (id, field, value) => {
  setGuarantors(prev =>
    prev.map(g => (g.id === id ? { ...g, [field]: value } : g))
  );
};

  const handleDocumentUpload = (e) => {
    const file = e.target.files[0];
    if (file && documentName.trim()) {
      const fileExtension = file.name.split('.').pop().toUpperCase();
      const newDocument = {
        id: Date.now(),
        name: documentName,
        fileName: file.name,
        format: fileExtension,
        file: file
      };
      setUploadedDocuments([...uploadedDocuments, newDocument]);
      setDocumentName('');
      e.target.value = ''; // Clear the file input
    }
  };

  const removeDocument = (id) => {
    setUploadedDocuments(uploadedDocuments.filter(doc => doc.id !== id));
  };
  const handleReset = () => {
    setCalcSelectedOption('');
    setLoanAmount('');
    setTenure('');
  }

  // Extract values safely from loanData
const principalAmount = parseFloat(loanData?.amount || 0);
const totalTenureMonths = parseInt(loanData?.repaymentTenure || 0);
// Fallback to your interestRate state variable if not present in selectedProductDetails
const reviewInterestRate = parseFloat(loanData?.selectedProductDetails?.interest_rate || interestRate || 0);

// Example calculation: Simple Interest (Flat Rate)
// Modify this mathematical formula if your system uses reducing balance or an annual percentage rate (APR)
const reviewInterestAmount = principalAmount * (reviewInterestRate / 100) * (totalTenureMonths / 12);
const reviewTotalRepayment = principalAmount + reviewInterestAmount;
const reviewMonthlyRepayment = totalTenureMonths > 0 ? (reviewTotalRepayment / totalTenureMonths) : 0;


const handleSubmit = async (e) => {
  e.preventDefault();

  setIsSaving(true);

  try {
    const token = localStorage.getItem("token");
    const companyId =
      localStorage.getItem("company_id") ||
      localStorage.getItem("companyId");
      const memberid = localStorage.getItem("memberId");

    const fd = new FormData();

    // Use the values computed from the actual form state (loanData)
    const principalAmount = parseFloat(loanData?.amount || 0);
    const totalTenureMonths = parseInt(loanData?.repaymentTenure || 0);
    const reviewInterestRate = parseFloat(loanData?.selectedProductDetails?.interest_rate || 0);

    // Calculate metrics directly to guarantee accuracy on submission
    const finalInterestAmount = principalAmount * (reviewInterestRate / 100) * (totalTenureMonths / 12);
    const finalTotalRepayment = principalAmount + finalInterestAmount;
    const finalMonthlyDeduction = totalTenureMonths > 0 ? (finalTotalRepayment / totalTenureMonths) : 0;

    // Loan Details
    fd.append("company_id", companyId);
    fd.append("member_id", memberid);
    fd.append("loan_name", loanData.loanType);
    fd.append("loan_purpose", loanData.loanPurpose);
    fd.append("principal_amount", loanData.amount);
    
    // CHANGED: Passing the correctly calculated form values instead of sidebar calculator states
    fd.append("interest_amount", finalInterestAmount.toFixed(2));
    fd.append("monthly_deduction", finalMonthlyDeduction.toFixed(2));
    fd.append("duration", loanData.repaymentTenure);
    fd.append("total_repayment", finalTotalRepayment.toFixed(2));

    guarantors.forEach((g) => {
      fd.append("guarantor_name[]", g.fullName);
      fd.append("guarantor_email[]", g.email);
      fd.append("guarantor_phone[]", g.phone);
      fd.append("guarantor_address[]", g.address);
      fd.append("guarantor_member_number[]", g.memberNumber);
    });

    // DOCUMENTS
    uploadedDocuments.forEach((doc) => {
      if (doc.file) {
        fd.append("document_name[]", doc.name);
        fd.append("document_path[]", doc.file, doc.file.name);
      }
    });

    console.log("Submitting Loan Application...");

    const response = await axios.post(
      `${BASE_URL}/member-auth/apply_for_loan`,
      fd,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        },
      }
    );

    Swal.fire({
      icon: "success",
      title: "Success",
      text: response.data?.message || "Loan application submitted successfully.",
      confirmButtonColor: "#2e7d32",
    });
    
    setGuarantors([]);
    navigate('/loans/my-loan-applications');

  } catch (error) {
    console.error(error);

    const msg =
      typeof error.response?.data?.message === "object"
        ? Object.values(error.response.data.message).flat().join(", ")
        : error.response?.data?.message || "An unexpected error occurred.";

    Swal.fire({
      icon: "error",
      title: "Submission Failed",
      text: msg,
      confirmButtonColor: "#d33",
    });
  } finally {
    setIsSaving(false);
  }
};



  return (
    <div className={styles.container}>
      {eligibilityLoading && (
  <div 
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      backdropFilter: 'blur(3px)',
      zIndex: 999999,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }}
  >
    {/* Beautiful CSS Spinner */}
    <div className="spinner-border text-success mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
      <span className="visually-hidden">Loading...</span>
    </div>
    <span className="fw-semibold text-dark" style={{ fontSize: '15px', letterSpacing: '0.5px' }}>
      Verifying loan eligibility...
    </span>
  </div>
)}
      {/* 1. APP SIDEBAR INTERFACE BAR LAYER */}
      <Sidebar2 />

      {/* 2. WORKING PRIMARY VIEWPORT FRAMEWORK WRAPPER */}
      <main className={styles.mainContent}>
        {/* APP UPPER RESPONSIVE NAVIGATION BAR HEADER */}
        <Header2 />

        {/* COMPONENT CENTRAL WORKSPACE DASHBOARD BLOCKS */}
        <div className={styles.workspace}>
          
          {/* STEP INDICATOR */}
          <div className={styles.stepsContainer}>
            <div className={styles.stepsWrapper}>
              {steps.map((step, index) => (
                <React.Fragment key={step.number}>
                  <div 
                    className={`${styles.stepIndicator} ${currentStep >= step.number ? styles.stepActive : ''} `}
                    onClick={() => goToStep(step.number)
                      
                    }
                    style={{ flex: 1 }}
                  >
                    <div className={styles.stepNumberBox}>
                        <div className={styles.stepNumber}>{step.number}
                        </div>
                        <div className={`${styles.stepLine} ${currentStep >= step.number ? styles.stepLineActive : ''}`}> 
                        </div>
                    </div>
                    <div className={styles.stepLabel}>
                      <p className={styles.stepTitle}>{step.title}</p>
                      <p className={styles.stepDesc}>{step.description}</p>
                    </div>
                    
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* STEP 1: LOAN DETAILS */}
          {currentStep === 1 && (
            <div className={styles.mainCard}>
                <div className={styles.cardOne}>
                    <div>
                        <h2 className={styles.stepContentTitle}>Loan Details</h2>
                        <p className={styles.stepContentDesc}>Provide the details of the loan you are applying for</p>
                    </div>
                    <div className={styles.formSection}>
                        <div className={styles.twoColForm}>
                            <div className={styles.formGroup}>
                                <label className={styles.label}>Loan Type <span>*</span></label>
                                <Select
                        options={loanProducts}
                        isLoading={isLoadingProducts}
                        onChange={handleSelectProductChange}
                        placeholder="Select Loan Type"
                        // className={styles.input}
                        // styles={customSelectStyles}
                        isClearable
                        value={loanProducts.find(opt => opt.value === loanData.loanType) || null}
                        styles={{
        control: (provided) => ({
          ...provided,
          minHeight: "40px",
          height: "40px",
          width: '100%',
          borderRadius: "6px",
          borderColor: eligibilityError ? "#ef4444" : isEligible ? "#22c55e" : "#d1d5db", // Red border on error, Green on Success
          fontSize: 13,
          boxShadow: "none",
          "&:hover": {
            borderColor: eligibilityError ? "#dc2626" : isEligible ? "#16a34a" : "#6b7280",
          },
        }),
        valueContainer: (provided) => ({
          ...provided,
          height: "40px",
          padding: "0 8px",
        }),
        input: (provided) => ({
          ...provided,
          margin: 0,
          padding: 0,
          fontSize: 13,
          width: '100%'
        }),
        indicatorsContainer: (provided) => ({
          ...provided,
          height: "40px",
        }),
        clearIndicator: (provided) => ({
          ...provided,
          padding: "4px",
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          padding: "4px",
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 99999,
          fontSize: 13
        }),
      }}
                      />
                      {eligibilityError && (
      <div 
        className="mt-2 d-flex align-items-center gap-2 rounded-2"
        style={{
          padding: '8px 12px',
          backgroundColor: '#fef2f2',
          border: '1px solid #fee2e2',
          color: '#b91c1c',
          fontSize: '12px',
          fontWeight: 500,
          lineHeight: '1.4'
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-circle-fill flex-shrink-0" viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
        </svg>
        <span>{eligibilityError}</span>
      </div>
    )}

    {/* SUCCESS VISUAL FEEDBACK (Sleek UI badge) */}
    {isEligible && !eligibilityError && !eligibilityLoading && (
      <div 
        className="mt-2 d-flex align-items-center gap-2 rounded-2"
        style={{
          padding: '8px 12px',
          backgroundColor: '#f0fdf4',
          border: '1px solid #dcfce7',
          color: '#15803d',
          fontSize: '12px',
          fontWeight: 500,
          lineHeight: '1.4'
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-circle-fill flex-shrink-0" viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
        </svg>
        <span>Eligible to Apply</span>
      </div>
    )}
                            </div>
                            <div className={styles.formGroup}>
                                <label className={styles.label}>Loan Purpose <span>*</span></label>
                                <select className={styles.input} name="loanPurpose" value={loanData.loanPurpose} onChange={handleChange}>
                                <option>Select Purpose</option>
                                <option>Education</option>
                                <option>Housing</option>
                                <option>Business</option>
                                <option>Other</option>
                                </select>
                            </div>
                        </div>

                      <div className={styles.twoColForm}>
  {/* Loan Amount Input */}
  <div className={styles.formGroup}>
    <label className={styles.label}>
      Loan Amount <span>*</span>
    </label>
    <CurrencyInput
      id="amount"
      name="amount"
      className={`${styles.input} ${amountError ? styles.inputError : ''}`}
      placeholder="₦ Enter amount"
      value={loanData.amount}
      onValueChange={(value) => {
        // Clear error message while user is actively typing a new value
        if (amountError) setAmountError('');
        handleCurrencyChange("amount", value);
      }}
      onBlur={handleAmountBlur} // Trigger range validation on exit
      prefix="₦ "
      groupSeparator=","
      decimalSeparator="."
      decimalsLimit={2}
    />
    
    {/* Dynamic validation text shown below the input */}
    {amountError && (
      <span className={styles.errorMessageText}>{amountError}</span>
    )}
  </div>

  {/* Repayment Tenure Input */}
  <div className={styles.formGroup}>
    <label className={styles.label}>
      Repayment Tenure (in months) <span>*</span>
    </label>
    <input 
      className={`${styles.input} ${tenureError ? styles.inputError : ''}`}
      type='text' 
      placeholder="Enter duration of a payment(s) in months" 
      name="repaymentTenure"
      value={loanData.repaymentTenure}
      onChange={(e) => {
        if (tenureError) setTenureError('');
        handleChange(e);
      }}
      onBlur={handleTenureBlur}
    />    
    
    {/* Dynamic validation text shown below the input */}
    {tenureError && (
      <span className={styles.errorMessageText}>{tenureError}</span>
    )}
  </div>
</div>
                        
                        {/* <div className={styles.twoColForm}> */}
                            {/* <div className={styles.formGroup}>
                                <label className={styles.label}>Repayment Method <span>*</span></label>
                                <select className={styles.input}>
                                    <option>Select Repayment Method</option>
                                    <option>Monthly Deduction</option>
                                    <option>Quarterly Deduction</option>
                                    <option>Annual Deduction</option>
                                </select>
                                <div className={styles.maxTextContainer}>
                                    <span className={styles.maxText}>How would you repay this loan?</span>
                                </div>
                            </div> */}

                            {/* <div className={styles.formGroup}>
                                <label className={styles.label}>Preferred Disbursement Account <span>*</span></label>
                                <div className={styles.selectWithPrefix}>
                                    <Landmark size={20} className={styles.Landmark} />
                                    <select className={styles.input} name="disbursementAccount" value={loanData.disbursementAccount} onChange={handleChange}>
                                    
                                        <option>Access Bank (****1234)</option>
                                        <option>GTBank (****5678)</option>
                                    </select>
                                </div>
                                <div className={styles.maxTextContainer}>
                                    <span className={styles.maxText}>Invalid bank account. Please update your bank details in your Profile</span>
                                </div>
                            </div> */}
                        {/* </div> */}
                        <div className={styles.infoBox}>
                            <Info size={30} color="#15803d" />
                            <div>
                                <p><strong>Important Information</strong></p>
                                <p>All loan applications are subject to review and approval. Please ensure all information provided is accurate and complete. 
                                  Use the Loan Calculator on the right to estimate your total repayment amount before submitting your loan application, helping to avoid any misunderstanding.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* NAVIGATION BUTTONS */}
                    <div className={styles.stepsNavigation}>
                        <button 
                        className={styles.backBtn}
                        onClick={handleBack}
                        disabled={currentStep === 1}
                        >
                        ← Back
                        </button>
                        <button 
                        className={styles.nextBtn}
                        onClick={handleNext}
                        disabled={!isCurrentStepValid()}
                        >
                        {currentStep === 4 ? 'Submit' : 'Next'} →
                        </button>
                    </div>
                    
                </div>
                <div className={styles.mainCardTwo}>
                  {/* LOAN ELIGIBILITY SECTION */}
                    <div className={styles.eligibilitySection}>
                        <h3 className={styles.sectionTitle}>Loan Summary</h3>
                        {/* <div className={styles.eligibilityStatus}>
                            <div className={styles.eligibilityCheck}>
                                <Check size={20} color="#15803d" />
                                <span>You are eligible to apply</span>
                            </div>
                        </div> */}
                        <div className={styles.eligibilityInfo}>
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Minimum Loan Amount</span>
                            <span className={styles.infoValue}>₦{parseFloat(loanData?.selectedProductDetails?.minimum_amount || 0.00).toLocaleString('en-US', {
                              minimumIntegerDigits: 1,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</span>
                            <span className={styles.infoLabel}>Maximum Loan Amount</span>
                            <span className={styles.infoValue}>₦{parseFloat(loanData?.selectedProductDetails?.max_amount || 0.00).toLocaleString('en-US', {
                              minimumIntegerDigits: 1,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Available Balance for Loan</span>
                            <span className={styles.infoValue}>₦{parseFloat(loanData?.selectedProductDetails?.max_amount || 0.00).toLocaleString('en-US', {
                              minimumIntegerDigits: 1,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Maximum Tenure</span>
                            <span className={styles.infoValue}>{loanData?.selectedProductDetails?.max_tenure || 0} Months</span>
                        </div>
                        </div>
                        {/* <a href="/" className={styles.viewPolicyLink}>
                        <span>View Loan Policy</span> <ArrowRight size={14} />
                        </a> */}
                    </div>

                  {/* LOAN CALCULATOR SECTION */}
                  <div className={styles.calculatorSection}>
                    <h3 className={styles.sectionTitle}>Loan Calculator</h3>
                    <div className={styles.calcForm}>
                      <div className={styles.calcFormGroup}>
                        <label className={styles.calcLabel}>Loan Type</label>
                        <div className={styles.calcInputWithCurrency}>
                          <Select
          options={loanProducts}
          isLoading={isLoadingProducts}
          onChange={handleCalcProductChange}
          placeholder="Select Loan Type"
          isClearable
          value={calcSelectedOption}
           styles={{

    control: (provided) => ({

      ...provided,

      minHeight: "35px",

      height: "35px",
         width: '100%',

      borderRadius: "6px",

      borderColor: "#d1d5db",

      fontSize: 13,

      boxShadow: "none",

      "&:hover": {

        borderColor: "#6b7280",

      },

    }),

    valueContainer: (provided) => ({

      ...provided,

      height: "35px",

      padding: "0 8px",

    }),

    input: (provided) => ({

      ...provided,

      margin: 0,

      padding: 0,

      fontSize: 13,
      width: '100%'

    }),

    indicatorsContainer: (provided) => ({

      ...provided,

      height: "35px",

    }),

    clearIndicator: (provided) => ({

      ...provided,

      padding: "4px",

    }),

    dropdownIndicator: (provided) => ({

      ...provided,

      padding: "4px",

    }),

    menu: (provided) => ({

      ...provided,

      zIndex: 99999,

      fontSize: 13

    }),

  }}

        />
                        </div>
                      </div>
                      <div className={styles.calcFormGroup}>
                        <label className={styles.calcLabel}>Loan Amount</label>
                        <div className={styles.calcInputWithCurrency}>
                          <span>₦</span>
                          <CurrencyInput
          id="loan-amount-input"
          name="loanAmount"
          placeholder="0"
          defaultValue={0}
          value={loanAmount}
          // onValueChange passes the raw numeric string directly ('1500000' instead of '₦1,500,000')
          onValueChange={(value) => setLoanAmount(value ? parseFloat(value) : 0)}
          decimalsLimit={2}
          allowNegativeValue={false}
          className={styles.calcInput}
        />
                        </div>
                      </div>

                      <div className={styles.calcFormGroup}>
                        <label className={styles.calcLabel}>Duration (in months)</label>
                        <input 
                          value={tenure}
                          onChange={(e) => setTenure(e.target.value)}
                          className={styles.calcInput}
                        />
                      </div>

                      <div className={styles.calcResult}>
                        <div className={styles.resultRow}>
                          <span>Loan Interest ({parseFloat(interestRate)}%)</span>
                          <strong>₦{parseFloat(estimatedInterest).toLocaleString('en-US', {
                              minimumIntegerDigits: 1,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</strong>
                        </div>
                        <div className={styles.resultRow}>
                          <span>Monthly Repayment</span>
                          <strong>₦{parseFloat(monthlyRepayment).toLocaleString('en-US', {
                              minimumIntegerDigits: 1,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</strong>
                        </div>
                        <div className={styles.resultRow}>
                          <span>Total Repayment</span>
                          <strong>₦{parseFloat(totalRepayment).toLocaleString('en-US', {
                              minimumIntegerDigits: 1,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</strong>
                        </div>
                        
                      </div>

                      <button className={styles.recalculateBtn} onClick={handleReset}>
                        ↻ Recalculate
                      </button>
                    </div>
                  </div>
                </div>
            </div>
          )}

          {/* STEP 2: GUARANTORS */}
          {currentStep === 2 && (
            <div className={styles.mainCard}>
                <div className={styles.cardOne}>
                    <div>
                        <h2 className={styles.stepContentTitle}>Guarantors</h2>
                        <p className={styles.stepContentDesc}>Add your guarantors to support your loan application</p>
                    </div>
                  <div className={styles.formSection}>
  {guarantorsRequired === 0 ? (
    /* NO GUARANTOR REQUIRED STATE */
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px',
      textAlign: 'center',
      backgroundColor: '#f8fafc',
      borderRadius: '8px',
      border: '1px dashed #cbd5e1',
      marginBottom: '25px'
    }}>
      <div style={{ fontSize: '2rem', marginBottom: '10px' }}>🎉</div>
      <h3 style={{ margin: '0 0 8px 0', color: '#0f172a', fontSize: '1.2rem' }}>No Guarantor Required</h3>
      <p style={{ margin: 0, color: '#64748b', fontSize: '0.95rem', maxWidth: '400px' }}>
        This specific loan option does not require any guarantor validation profiles. You can proceed directly to the next stage.
      </p>
    </div>
  ) : (
    /* REGULAR GUARANTOR LOOP */
    <>
      {guarantors.map((guarantor, index) => {
        const remainingRequired = guarantorsRequired - guarantors.filter(g => g.fetched).length;

        return (
          <div key={guarantor.id} className={styles.guarantorBox}>
            <div className={styles.guarantorHeader}>
              <h3>Guarantor {index + 1}</h3>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {remainingRequired > 0 && (
                  <span className={styles.requiredBadge}>
                    {remainingRequired} more required
                  </span>
                )}
                
                {guarantors.length > 1 && (
                  <button 
                    className={styles.removeGuarantorBtn}
                    onClick={() => removeGuarantor(guarantor.id)}
                    type="button"
                    style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '0.85rem' }}
                  >
                    ✕ Remove
                  </button>
                )}
              </div>
            </div>

            {/* MEMBER NUMBER SEARCH ROW */}
            <div className={styles.memberSearchRow} style={{ display: 'flex', gap: '10px', alignItems: 'flex-end', marginBottom: '15px' }}>
              <div className={styles.formGroup} style={{ flex: 1 }}>
                <label className={styles.label}>Member Number <span>*</span></label>
                <input 
                  type="text" 
                  placeholder="Enter member number" 
                  className={styles.input}
                  value={guarantor.memberNumber || ''}
                  onChange={(e) => handleGuarantorChange(guarantor.id, 'memberNumber', e.target.value)}
                  disabled={guarantor.fetched}
                />
              </div>
             
              <button
                type="button"
                className={styles.fetchMemberBtn}
                onClick={() => handleFetchMember(guarantor.id, guarantor.memberNumber)}
                disabled={memberLoading || guarantor.fetched}
                style={{ padding: '10px 15px', height: '42px' }}
              >
                {guarantor.fetched ? "Verified ✓" : memberLoading ? "Searching..." : "Fetch Details"}
              </button>
            </div>
             {guarantorError && (
        <span className={styles.errorMessageText21}>{guarantorError}</span>
    )}

            {/* AUTO-FILLED GUARANTOR DETAILS */}
            <div className={styles.twoColForm}>
              <div className={styles.formGroup}>
                <label className={styles.label}>Full Name <span>*</span></label>
                <input 
                  type="text" 
                  className={styles.input}
                  value={guarantor.fullName || ''}
                  readOnly
                  placeholder="Fetched name will appear here"
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Email <span>*</span></label>
                <input 
                  type="email" 
                  className={styles.input}
                  value={guarantor.email || ''}
                  readOnly
                  placeholder="Fetched email will appear here"
                />
              </div>
            </div>

            <div className={styles.twoColForm}>
              <div className={styles.formGroup}>
                <label className={styles.label}>Phone Number <span>*</span></label>
                <input 
                  type="tel" 
                  className={styles.input}
                  value={guarantor.phone || ''}
                  readOnly
                  placeholder="Fetched phone number"
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Address <span>*</span></label>
                <input 
                  type="text" 
                  className={styles.input}
                  value={guarantor.address || ''}
                  readOnly
                  placeholder="Fetched address"
                />
              </div>
            </div>
          </div>
        );
      })}

      {/* Manual Slot Customizer button rule */}
      {guarantors.length < guarantorsRequired && (
        <div style={{ marginBottom: '20px' }}>
          <button 
            className={styles.addGuarantorBtn}
            onClick={addGuarantor}
            type="button"
            style={{ 
              padding: '8px 16px', 
              borderRadius: '6px', 
              cursor: 'pointer', 
              border: '1px solid #cbd5e1', 
              backgroundColor: '#fff',
              color: '#2563eb',
              fontWeight: '500'
            }}
          >
            + Add Guarantor Slot ({guarantors.length} of {guarantorsRequired})
          </button>
        </div>
      )}
    </>
  )}

  {/* Existing Requirements Info Alert component */}
  <div className={styles.infoBox}>
    <Info size={30} color="#15803d" />
    <div>
      <p><strong>Guarantor Requirements</strong></p>
      <p>A guarantor must be a member of the cooperative society and of good standing and willing to assume responsibility should you default on your loan repayment.</p>
    </div>
  </div>
</div>

                    {/* NAVIGATION BUTTONS */}
                    <div className={styles.stepsNavigation}>
                        <button 
                        className={styles.backBtn}
                        onClick={handleBack}
                        disabled={currentStep === 1}
                        >
                        ← Back
                        </button>
                        <button 
                        className={styles.nextBtn}
                        onClick={handleNext}
                        disabled={!isCurrentStepValid()}
                        >
                        {currentStep === 4 ? 'Submit' : 'Next'} →
                        </button>
                    </div>
                    
                </div>
              <div className={styles.mainCardTwo}>
                  {/* LOAN ELIGIBILITY SECTION */}
                    <div className={styles.eligibilitySection}>
                        <h3 className={styles.sectionTitle}>Loan Summary</h3>
                        {/* <div className={styles.eligibilityStatus}>
                            <div className={styles.eligibilityCheck}>
                                <Check size={20} color="#15803d" />
                                <span>You are eligible to apply</span>
                            </div>
                        </div> */}
                        <div className={styles.eligibilityInfo}>
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Minimum Loan Amount</span>
                            <span className={styles.infoValue}>₦{parseFloat(loanData?.selectedProductDetails?.minimum_amount || 0.00).toLocaleString('en-US', {
                              minimumIntegerDigits: 1,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</span>
                            <span className={styles.infoLabel}>Maximum Loan Amount</span>
                            <span className={styles.infoValue}>₦{parseFloat(loanData?.selectedProductDetails?.max_amount || 0.00).toLocaleString('en-US', {
                              minimumIntegerDigits: 1,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Available Balance for Loan</span>
                            <span className={styles.infoValue}>₦{parseFloat(loanData?.selectedProductDetails?.max_amount || 0.00).toLocaleString('en-US', {
                              minimumIntegerDigits: 1,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Maximum Tenure</span>
                            <span className={styles.infoValue}>{loanData?.selectedProductDetails?.max_tenure || 0} Months</span>
                        </div>
                        </div>
                        {/* <a href="/" className={styles.viewPolicyLink}>
                        <span>View Loan Policy</span> <ArrowRight size={14} />
                        </a> */}
                    </div>

                  {/* LOAN CALCULATOR SECTION */}
                  <div className={styles.calculatorSection}>
                    <h3 className={styles.sectionTitle}>Loan Calculator</h3>
                    <div className={styles.calcForm}>
                      <div className={styles.calcFormGroup}>
                        <label className={styles.calcLabel}>Loan Type</label>
                        <div className={styles.calcInputWithCurrency}>
                          <Select
          options={loanProducts}
          isLoading={isLoadingProducts}
          onChange={handleCalcProductChange}
          placeholder="Select Loan Type"
          isClearable
          value={calcSelectedOption}
           styles={{

    control: (provided) => ({

      ...provided,

      minHeight: "35px",

      height: "35px",
        width: '300px',

      borderRadius: "6px",

      borderColor: "#d1d5db",

      fontSize: 13,

      boxShadow: "none",

      "&:hover": {

        borderColor: "#6b7280",

      },

    }),

    valueContainer: (provided) => ({

      ...provided,

      height: "35px",

      padding: "0 8px",

    }),

    input: (provided) => ({

      ...provided,

      margin: 0,

      padding: 0,

      fontSize: 13,
      width: '100%'

    }),

    indicatorsContainer: (provided) => ({

      ...provided,

      height: "35px",

    }),

    clearIndicator: (provided) => ({

      ...provided,

      padding: "4px",

    }),

    dropdownIndicator: (provided) => ({

      ...provided,

      padding: "4px",

    }),

    menu: (provided) => ({

      ...provided,

      zIndex: 99999,

      fontSize: 13

    }),

  }}

        />
                        </div>
                      </div>
                      <div className={styles.calcFormGroup}>
                        <label className={styles.calcLabel}>Loan Amount</label>
                        <div className={styles.calcInputWithCurrency}>
                          <span>₦</span>
                          <CurrencyInput
          id="loan-amount-input"
          name="loanAmount"
          placeholder="0"
          defaultValue={0}
          value={loanAmount}
          // onValueChange passes the raw numeric string directly ('1500000' instead of '₦1,500,000')
          onValueChange={(value) => setLoanAmount(value ? parseFloat(value) : 0)}
          decimalsLimit={2}
          allowNegativeValue={false}
          className={styles.calcInput}
        />
                        </div>
                      </div>

                      <div className={styles.calcFormGroup}>
                        <label className={styles.calcLabel}>Duration (in months)</label>
                        <input 
                          value={tenure}
                          onChange={(e) => setTenure(e.target.value)}
                          className={styles.calcInput}
                        />
                      </div>

                      <div className={styles.calcResult}>
                        <div className={styles.resultRow}>
                          <span>Loan Interest ({parseFloat(interestRate)}%)</span>
                          <strong>₦{parseFloat(estimatedInterest).toLocaleString('en-US', {
                              minimumIntegerDigits: 1,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</strong>
                        </div>
                        <div className={styles.resultRow}>
                          <span>Monthly Repayment</span>
                          <strong>₦{parseFloat(monthlyRepayment).toLocaleString('en-US', {
                              minimumIntegerDigits: 1,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</strong>
                        </div>
                        <div className={styles.resultRow}>
                          <span>Total Repayment</span>
                          <strong>₦{parseFloat(totalRepayment).toLocaleString('en-US', {
                              minimumIntegerDigits: 1,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</strong>
                        </div>
                        
                      </div>

                      <button className={styles.recalculateBtn} onClick={handleReset}>
                        ↻ Recalculate
                      </button>
                    </div>
                  </div>
                </div>
            </div>
          )}

          {/* STEP 3: DOCUMENTS */}
         {currentStep === 3 && (
  <div className={styles.mainCard}>
    <div className={styles.cardOne}>
      <div>
        <h2 className={styles.stepContentTitle}>Documents</h2>
        <p className={styles.stepContentDesc}>Add and upload your documents for your application profile</p>
      </div>

      <div className={styles.formSection}>
        
        {/* TOP PANEL: ENTER FRESH DOCUMENT DETAILS */}
        <div style={{
          backgroundColor: '#f8fafc',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '24px'
        }}>
          <h4 style={{ margin: '0 0 10px 0', fontSize: '0.95rem', color: '#334155' }}>Add a New Document</h4>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <input 
              type="text"
              placeholder="Enter document description (e.g., Payslip, National ID)..."
              className={styles.input}
              style={{ flex: 1, height: '40px' }}
              value={documentName}
              onChange={(e) => setDocumentName(e.target.value)}
            />
            <label 
              className={styles.addGuarantorBtn} 
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0 16px',
                height: '40px',
                borderRadius: '6px',
                cursor: documentName.trim() ? 'pointer' : 'not-allowed',
                border: '1px solid #cbd5e1',
                backgroundColor: documentName.trim() ? '#fff' : '#f1f5f9',
                color: documentName.trim() ? '#16a34a' : '#94a3b8',
                fontWeight: '500',
                margin: 0
              }}
            >
              <input 
                type="file" 
                accept=".pdf,.jpg,.jpeg,.png"
                style={{ display: 'none',  }}
                disabled={!documentName.trim()}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const ext = file.name.split('.').pop().toUpperCase();
                    setUploadedDocuments(prev => [...prev, {
                      id: Date.now(),
                      name: documentName.trim(),
                      fileName: file.name,
                      format: ext,
                      file: file
                    }]);
                    setDocumentName(''); // Reset input text field after selection
                  }
                }}
              />
              + Choose File & Add
            </label>
          </div>
          <p style={{ margin: '6px 0 0 0', fontSize: '0.8rem', color: '#64748b' }}>
            Type your custom description first, then click "Choose File & Add" to append it freshly.
          </p>
        </div>

        {/* DYNAMIC FRESH UPLOADED LIST */}
        <div className={styles.documentBox} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <h3 style={{ margin: '0 0 4px 0' }}>Uploaded Attachments</h3>

          {uploadedDocuments.length === 0 ? (
            /* Empty State Message */
            <div style={{
              textAlign: 'center',
              padding: '30px 20px',
              color: '#64748b',
              border: '1px dashed #cbd5e1',
              borderRadius: '8px',
              backgroundColor: '#f8fafc',
              fontSize: '0.9rem'
            }}>
              No documents added yet. Type a description above to upload your first file.
            </div>
          ) : (
            /* Document Row Mapping */
            uploadedDocuments.map((doc) => (
              <div key={doc.id} style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '14px 16px',
                border: '1px solid #10b981',
                borderRadius: '8px',
                backgroundColor: '#f0fdf4'
              }}>
                {/* Left Side: Custom Description Label */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1, paddingRight: '16px' }}>
                  <FileText size={24} color="#10b981" />
                  <div>
                    <p style={{ margin: 0, fontWeight: '600', color: '#166534', fontSize: '0.95rem' }}>{doc.name}</p>
                    <span style={{ fontSize: '0.8rem', color: '#15803d', display: 'block', wordBreak: 'break-all' }}>
                      ✓ {doc.fileName} ({doc.format})
                    </span>
                  </div>
                </div>

                {/* Right Side: Delete Row Control */}
                <button
                  type="button"
                  onClick={() => setUploadedDocuments(prev => prev.filter(item => item.id !== doc.id))}
                  style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '500', whiteSpace: 'nowrap' }}
                >
                  ✕ Remove
                </button>
              </div>
            ))
          )}
        </div>

        {/* FORMAT AND FILE GUIDELINES WARNING */}
        <div className={styles.infoBox} style={{ marginTop: '20px' }}>
          <Info size={30} color="#15803d" />
          <div>
            <p><strong>Document Guidelines</strong></p>
            <p>Supported file formats: **PDF, JPG, JPEG, PNG**. Recommended max size limit: **5MB** per file.</p>
          </div>
        </div>
      </div>

      {/* NAVIGATION CONTROLS */}
      <div className={styles.stepsNavigation}>
        <button className={styles.backBtn} onClick={handleBack} disabled={currentStep === 1}>
          ← Back
        </button>
        <button className={styles.nextBtn} onClick={handleNext} disabled={!isCurrentStepValid()}>
          {currentStep === 4 ? 'Submit' : 'Next'} →
        </button>
      </div>
    </div>

    {/* ELIGIBILITY PROFILE PANEL ON THE RIGHT */}
    <div className={styles.mainCardTwo}>
      <div className={styles.eligibilitySection}>
        <h3 className={styles.sectionTitle}>Loan Summary</h3>
        {/* <div className={styles.eligibilityStatus}>
          <div className={styles.eligibilityCheck}>
            <Check size={20} color="#15803d" />
            <span>You are eligible to apply</span>
          </div>
        </div> */}
        <div className={styles.eligibilityInfo}>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Minimum Loan Amount</span>
            <span className={styles.infoValue}>₦{parseFloat(loanData?.selectedProductDetails?.minimum_amount || 0.00).toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
            <span className={styles.infoLabel}>Maximum Loan Amount</span>
            <span className={styles.infoValue}>₦{parseFloat(loanData?.selectedProductDetails?.max_amount || 0.00).toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Available Balance for Loan</span>
            <span className={styles.infoValue}>₦{parseFloat(loanData?.selectedProductDetails?.max_amount || 0.00).toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Maximum Tenure</span>
            <span className={styles.infoValue}>{loanData?.selectedProductDetails?.max_tenure || 0} Months</span>
          </div>
        </div>
        {/* <a href="/" className={styles.viewPolicyLink}>
          <span>View Loan Policy</span> <ArrowRight size={14} />
        </a> */}
      </div>

      {/* LOAN CALCULATOR SECTION */}
      <div className={styles.calculatorSection}>
        <h3 className={styles.sectionTitle}>Loan Calculator</h3>
        <div className={styles.calcForm}>
          <div className={styles.calcFormGroup}>
            <label className={styles.calcLabel}>Loan Type</label>
            <div className={styles.calcInputWithCurrency}>
              <Select
                options={loanProducts}
                isLoading={isLoadingProducts}
                onChange={handleCalcProductChange}
                placeholder="Select Loan Type"
                isClearable
                value={calcSelectedOption}
                styles={{
                  control: (prov) => ({ ...prov, minHeight: "35px", height: "35px", width: '100%', borderRadius: "6px", fontSize: 13, boxShadow: "none" }),
                  valueContainer: (prov) => ({ ...prov, height: "35px", padding: "0 8px" }),
                  input: (prov) => ({ ...prov, margin: 0, padding: 0, fontSize: 13 }),
                  menu: (prov) => ({ ...prov, zIndex: 99999, fontSize: 13 })
                }}
              />
            </div>
          </div>
          <div className={styles.calcFormGroup}>
            <label className={styles.calcLabel}>Loan Amount</label>
            <div className={styles.calcInputWithCurrency}>
              <span>₦</span>
              <CurrencyInput
                id="loan-amount-input"
                name="loanAmount"
                placeholder="0"
                value={loanAmount}
                onValueChange={(val) => setLoanAmount(val ? parseFloat(val) : 0)}
                decimalsLimit={2}
                allowNegativeValue={false}
                className={styles.calcInput}
              />
            </div>
          </div>

          <div className={styles.calcFormGroup}>
            <label className={styles.calcLabel}>Duration (in months)</label>
            <input 
              value={tenure}
              onChange={(e) => setTenure(e.target.value)}
              className={styles.calcInput}
            />
          </div>

          <div className={styles.calcResult}>
            <div className={styles.resultRow}>
              <span>Loan Interest ({parseFloat(interestRate)}%)</span>
              <strong>₦{parseFloat(estimatedInterest).toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong>
            </div>
            <div className={styles.resultRow}>
              <span>Monthly Repayment</span>
              <strong>₦{parseFloat(monthlyRepayment).toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong>
            </div>
            <div className={styles.resultRow}>
              <span>Total Repayment</span>
              <strong>₦{parseFloat(totalRepayment).toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong>
            </div>
          </div>

          <button className={styles.recalculateBtn} onClick={handleReset}>
            ↻ Recalculate
          </button>
        </div>
      </div>
    </div>
  </div>
)}

          {/* STEP 4: REVIEW & SUBMIT */}
          {currentStep === 4 && (
  <div className={styles.mainCard}>
    <div className={styles.cardOne}>
      <div>
        <h2 className={styles.stepContentTitle}>Review & Submit</h2>
        <p className={styles.stepContentDesc}>Review your application before final submission</p>
      </div>
      <div className={styles.formSection}>
        
        {/* 1. LOAN DETAILS REVIEW CATEGORY */}
        <div className={styles.reviewBox}>
          <h3>Loan Details</h3>
          <div className={styles.reviewRow}>
            <span>Loan Type:</span>
            <strong>{loanData.selectedProductDetails?.loan_name || 'Not selected'}</strong>
          </div>
          <div className={styles.reviewRow}>
            <span>Loan Purpose:</span>
            <strong>{loanData.loanPurpose || 'Not selected'}</strong>
          </div>
          <div className={styles.reviewRow}>
            <span>Principal Amount:</span>
            <strong>₦{parseFloat(loanData?.amount || 0.00).toLocaleString('en-US', {
                              minimumIntegerDigits: 1,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</strong>
          </div>
          <div className={styles.reviewRow}>
            <span>Repayment Tenure:</span>
            <strong>{loanData.repaymentTenure} Months</strong>
          </div>

          <div className={styles.reviewRow}>
    <span>Loan Interest Amount ({reviewInterestRate}%):</span>
    <strong>
      ₦{reviewInterestAmount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}
    </strong>
  </div>

  <div className={styles.reviewRow}>
    <span>Monthly Repayment:</span>
    <strong>
      ₦{reviewMonthlyRepayment.toLocaleString('en-US', { 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
      })}
    </strong>
  </div>

  <div className={styles.reviewRow} style={{ borderTop: '1px solid #e2e8f0', paddingTop: '8px', marginTop: '4px' }}>
    <span>Total Repayment:</span>
    <strong style={{ color: '#1e293b', fontSize: '1.05rem' }}>
      ₦{reviewTotalRepayment.toLocaleString('en-US', { 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
      })}
    </strong>
  </div>
        </div>

        {/* 2. GUARANTORS INFORMATION REVIEW CATEGORY */}
        <div className={styles.reviewBox}>
          <h3>Guarantors Information</h3>
          {guarantors && guarantors.length > 0 ? (
            guarantors.map((guarantor, index) => (
              <div key={guarantor.id} className={styles.guarantorReviewSection} style={{ marginBottom: '16px', borderBottom: index !== guarantors.length - 1 ? '1px dashed #e2e8f0' : 'none', paddingBottom: '12px' }}>
                <h4 style={{ margin: '4px 0 8px 0', color: '#1e293b' }}>Guarantor {index + 1}</h4>
                <div className={styles.reviewRow}>
                  <span>Full Name:</span>
                  <strong>{guarantor.fullName || 'Not provided'}</strong>
                </div>
                <div className={styles.reviewRow}>
                  <span>Email:</span>
                  <strong>{guarantor.email || 'Not provided'}</strong>
                </div>
                <div className={styles.reviewRow}>
                  <span>Phone Number:</span>
                  <strong>{guarantor.phone || 'Not provided'}</strong>
                </div>
                <div className={styles.reviewRow}>
                  <span>Address:</span>
                  <strong>{guarantor.address || 'Not provided'}</strong>
                </div>
                <div className={styles.reviewRow}>
                  <span>Member Number:</span>
                  <strong>{guarantor.memberNumber || 'Not provided'}</strong>
                </div>
              </div>
            ))
          ) : (
            <p style={{ color: '#64748b', margin: 0 }}>No guarantors required or added for this loan product.</p>
          )}
        </div>

        {/* 3. UPLOADED DOCUMENTS PREVIEW CATEGORY */}
        <div className={styles.reviewBox}>
          <h3>Uploaded Documents</h3>
          {uploadedDocuments && uploadedDocuments.length > 0 ? (
            <div className={styles.documentsReviewList} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {uploadedDocuments.map((doc) => {
                // Generate secure runtime URLs for uploaded dynamic files
                const fileUrl = doc.file ? URL.createObjectURL(doc.file) : null;
                const isImage = ['JPG', 'JPEG', 'PNG'].includes(doc.format?.toUpperCase());

                return (
                  <div 
                    key={doc.id} 
                    className={styles.documentReviewItem}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '10px 12px',
                      backgroundColor: '#f8fafc',
                      border: '1px solid #e2e8f0',
                      borderRadius: '6px'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <FileText size={18} color="#16a34a" />
                      <span style={{ fontWeight: '500', color: '#334155', whiteSpace: 'nowrap' }}>{doc.name}</span>
                      {/* <span className={styles.documentFormatBadge} style={{ fontSize: '0.75rem', backgroundColor: '#e2e8f0', padding: '2px 6px', borderRadius: '4px' }}> */}
                        {/* {doc.format} */}
                        {doc.format === 'PDF' ? <FaFilePdf color='red' size={18}/> : <FaFileImage color='#17093e' size={18} />}
                      {/* </span> */}
                    </div>

                    {fileUrl && (
                      <button
                        type="button"
                        style={{
                          background: 'none',
                          border: 'none',
                          // color: '#2563eb',
                          cursor: 'pointer',
                          fontWeight: '500',
                          fontSize: '0.85rem',
                          textDecoration: 'underline'
                        }}
                        onClick={() => {
                          // Handle modal or direct window view safely context-aware
                          if (isImage) {
                            // If your layout contains an injection modal target state variable:
                            if (typeof setSelectedPreviewImage === 'function') {
                              setSelectedPreviewImage(fileUrl);
                            } else {
                              window.open(fileUrl, '_blank');
                            }
                          } else {
                            // PDFs trigger safe system window tabs
                            window.open(fileUrl, '_blank');
                          }
                        }}
                      >
                       <ScanEye color='#16a34a'/>
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <p style={{ color: '#64748b', margin: 0 }}>No attachments uploaded.</p>
          )}
        </div>

        <div className={styles.infoBox} style={{ backgroundColor: '#f0fdf4', borderColor: '#86efac' }}>
          <Info size={30} color="#15803d" />
          <div>
            <p><strong>Ready to Submit?</strong></p>
            <p>Once you submit this application, it will be sent for review and approval. You will receive updates via email and SMS.</p>
          </div>
        </div>
      </div>

      {/* NAVIGATION BUTTONS */}
      <div className={styles.stepsNavigation}>
        <button className={styles.backBtn} onClick={handleBack} disabled={currentStep === 1}>
          ← Back
        </button>
        <button disabled={isSaving} className={styles.nextBtn} onClick={handleSubmit}>
          {isSaving ? 'Submitting...' : 'Submit  →'}
        </button>
      </div>
    </div>

    {/* LOAN ELIGIBILITY & SIDEBAR CALCULATOR RIGHT SECTION */}
    <div className={styles.mainCardTwo}>
      <div className={styles.eligibilitySection}>
        <h3 className={styles.sectionTitle}>Loan Summary</h3>
        {/* <div className={styles.eligibilityStatus}>
          <div className={styles.eligibilityCheck}>
            <Check size={20} color="#15803d" />
            <span>You are eligible to apply</span>
          </div>
        </div> */}
        <div className={styles.eligibilityInfo}>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Minimum Loan Amount</span>
            <span className={styles.infoValue}>₦{parseFloat(loanData?.selectedProductDetails?.minimum_amount || 0.00).toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
            <span className={styles.infoLabel}>Maximum Loan Amount</span>
            <span className={styles.infoValue}>₦{parseFloat(loanData?.selectedProductDetails?.max_amount || 0.00).toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Available Balance for Loan</span>
            <span className={styles.infoValue}>₦{parseFloat(loanData?.selectedProductDetails?.max_amount || 0.00).toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Maximum Tenure</span>
            <span className={styles.infoValue}>{loanData?.selectedProductDetails?.max_tenure || 0} Months</span>
          </div>
        </div>
        {/* <a href="/" className={styles.viewPolicyLink}>
          <span>View Loan Policy</span> <ArrowRight size={14} />
        </a> */}
      </div>

      <div className={styles.calculatorSection}>
        <h3 className={styles.sectionTitle}>Loan Calculator</h3>
        <div className={styles.calcForm}>
          <div className={styles.calcFormGroup}>
            <label className={styles.calcLabel}>Loan Type</label>
            <div className={styles.calcInputWithCurrency}>
              <Select
                options={loanProducts}
                isLoading={isLoadingProducts}
                onChange={handleCalcProductChange}
                placeholder="Select Loan Type"
                isClearable
                value={calcSelectedOption}
                styles={{
                  control: (provided) => ({ ...provided, minHeight: "35px", height: "35px", width: '100%', borderRadius: "6px", fontSize: 13, boxShadow: "none" }),
                  valueContainer: (provided) => ({ ...provided, height: "35px", padding: "0 8px" }),
                  input: (provided) => ({ ...provided, margin: 0, padding: 0, fontSize: 13 }),
                  menu: (provided) => ({ ...provided, zIndex: 99999, fontSize: 13 })
                }}
              />
            </div>
          </div>
          <div className={styles.calcFormGroup}>
            <label className={styles.calcLabel}>Loan Amount</label>
            <div className={styles.calcInputWithCurrency}>
              <span>₦</span>
              <CurrencyInput
                id="loan-amount-input"
                name="loanAmount"
                placeholder="0"
                value={loanAmount}
                onValueChange={(value) => setLoanAmount(value ? parseFloat(value) : 0)}
                decimalsLimit={2}
                allowNegativeValue={false}
                className={styles.calcInput}
              />
            </div>
          </div>

          <div className={styles.calcFormGroup}>
            <label className={styles.calcLabel}>Duration (in months)</label>
            <input 
              value={tenure}
              onChange={(e) => setTenure(e.target.value)}
              className={styles.calcInput}
            />
          </div>

          <div className={styles.calcResult}>
            <div className={styles.resultRow}>
              <span>Loan Interest ({parseFloat(interestRate)}%)</span>
              <strong>₦{parseFloat(estimatedInterest).toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong>
            </div>
            <div className={styles.resultRow}>
              <span>Monthly Repayment</span>
              <strong>₦{parseFloat(monthlyRepayment).toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong>
            </div>
            <div className={styles.resultRow}>
              <span>Total Repayment</span>
              <strong>₦{parseFloat(totalRepayment).toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong>
            </div>
          </div>

          <button className={styles.recalculateBtn} onClick={handleReset}>
            ↻ Recalculate
          </button>
        </div>
      </div>
    </div>
  </div>
)}

        </div>
      </main>
      {/* DOCUMENT PREVIEW MODAL */}
{selectedPreviewImage && (
  <div 
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999999,
      padding: '20px'
    }}
    onClick={() => setSelectedPreviewImage(null)} // Closes when clicking background
  >
    <div 
      style={{
        position: 'relative',
        backgroundColor: '#fff',
        padding: '12px',
        borderRadius: '8px',
        maxWidth: '90%',
        maxHeight: '90%',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
        display: 'flex',
        flexDirection: 'column'
      }}
      onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside the modal
    >
      <button 
        onClick={() => setSelectedPreviewImage(null)}
        style={{
          position: 'absolute',
          top: '-15px',
          right: '-15px',
          background: '#ef4444',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          width: '30px',
          height: '30px',
          cursor: 'pointer',
          fontWeight: 'bold',
          fontSize: '14px',
          boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
        }}
      >
        ✕
      </button>
      <img 
        src={selectedPreviewImage} 
        alt="Document Preview" 
        style={{ 
          maxWidth: '100%', 
          maxHeight: '80vh', 
          objectFit: 'contain',
          borderRadius: '4px' 
        }} 
      />
    </div>
  </div>
)}
    </div>
  );
}